var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "document-form" },
    [
      _c("TabHeaderComponent", {
        attrs: { buttons: _vm.buttons, title: _vm.title },
        on: {
          saveForm: _vm.onSaveForm,
          closeForm: _vm.onCloseForm,
          removeItem: _vm.onRemoveItem,
        },
      }),
      _vm.tabs && _vm.tabs.length
        ? _c("TabsComponent", {
            ref: "tabComponent",
            staticClass: "tabs-secondary-styles",
            attrs: {
              tabs: _vm.tabs,
              context: _vm.context,
              permissionsEntityProp: _vm.permissionsEntity,
            },
            on: {
              "changed-tab": _vm.tabChanged,
              simpleGridActionNew: _vm.onIntervenerActionNew,
              simpleGridActionRemove: _vm.onIntervenerActionRemove,
              simpleGridActionEdit: _vm.onIntervenerActionEdit,
              "form-created": _vm.onCreatedForm,
              renderForm: _vm.onRenderForm,
              "form-open": _vm.onOpenIntervenerForm,
              "form-save": _vm.onSaveIntervenerForm,
              "form-close": _vm.onCloseIntervenerForm,
              "form-mounted": _vm.onInitDocumentForm,
              onTabHeaderRemoveItem: _vm.removeIntervener,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }